import {FirebaseTopicModel} from "../firebase-topic-model";
import {BankrollUpdateEventData, RawBankrollUpdateMessage} from "./bankroll-updates-topic.model.interface";


export class BankrollUpdatesTopicModel extends FirebaseTopicModel<RawBankrollUpdateMessage, BankrollUpdateEventData> {
    getTopicName(): string {
        return "bankroll";
    }

    getTopicLabel(): string {
        return "Bankroll";
    }

    protected _getSubscriptionParams(): Record<string, any> {
        return {
            currency: this.services.currency.currencyIso3
        };
    }

    protected _mapRawMessageToPublishMessage(rawMessage: RawBankrollUpdateMessage): BankrollUpdateEventData {
        const bonusMoney = rawMessage.casinoRM || 0;

        return  {
            TotalBankroll: rawMessage.realBR + bonusMoney,
            Currency: rawMessage.currency,
            RealMoneyBankroll: rawMessage.realBR,
        };
    }

    protected notifyListeners(rawMessage: RawBankrollUpdateMessage) {
        super.notifyListeners(rawMessage);
        if(this.services.user.isVip) {
            this.analytics.sendMessageUpdate(this.getTopicLabel(), JSON.stringify(rawMessage));
        }
    }
}